import { IPageBigHeader, IPageHeaderBlock, IPageSimpleHeader, IPageSmallHeader } from '@features/cms/typescript';
import PageHeaderSimpleBlock from '@features/cms/components/pages/PageHeaderBlock/PageHeaderSimpleBlock/PageHeaderSimpleBlock';
import PageHeaderBigBlock from '@features/cms/components/pages/PageHeaderBlock/PageHeaderBigBlock/PageHeaderBigBlock';
import PageHeaderSmallBlock from '@features/cms/components/pages/PageHeaderBlock/PageHeaderSmallBlock/PageHeaderSmallBlock';
import theme from '@styles/theme';
type PropsType = {
  data: IPageHeaderBlock<IPageSimpleHeader | IPageSmallHeader | IPageBigHeader>;
  isFirst?: boolean;
  defaultBackground?: string;
};
const PageHeaderBlock = ({
  data,
  isFirst = false,
  defaultBackground = theme.rawColors.beige500
}: PropsType) => {
  const isSimpleHeader = (object: IPageHeaderBlock<IPageSimpleHeader | IPageSmallHeader | IPageBigHeader>): object is IPageHeaderBlock<IPageSimpleHeader> => 'headerType' in object && object.headerType === 'simple';
  const isBigHeader = (object: IPageHeaderBlock<IPageSimpleHeader | IPageSmallHeader | IPageBigHeader>): object is IPageHeaderBlock<IPageBigHeader> => 'headerType' in object && object.headerType === 'big';
  const isSmallHeader = (object: IPageHeaderBlock<IPageSimpleHeader | IPageSmallHeader | IPageBigHeader>): object is IPageHeaderBlock<IPageSmallHeader> => 'headerType' in object && object.headerType === 'small';
  if (isSimpleHeader(data)) return <PageHeaderSimpleBlock data={data} isFirst={isFirst} defaultBackground={defaultBackground} />;
  if (isBigHeader(data)) return <PageHeaderBigBlock data={data} isFirst={isFirst} defaultBackground={defaultBackground} />;
  if (isSmallHeader(data)) return <PageHeaderSmallBlock data={data} isFirst={isFirst} defaultBackground={defaultBackground} />;
  return null;
};
export default PageHeaderBlock;